"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tss = require("../styles/tss");
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsLabel',
  uniqId: '3O9KlM'
})((theme, _params, classes) => {
  const {
    spacing
  } = theme;
  return {
    root: {},
    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    startIcon: {},
    endIcon: {},
    withIcon: {
      display: 'inline-flex',
      alignItems: 'center',
      '& svg': {
        verticalAlign: 'middle'
      }
    },
    sizeXxs: {
      [`& > .${classes.startIcon}`]: {
        marginRight: spacing(0.5)
      },
      [`& > .${classes.endIcon}`]: {
        marginLeft: spacing(0.5)
      }
    },
    sizeXs: {
      [`& > .${classes.startIcon}`]: {
        marginRight: spacing(0.5)
      },
      [`& > .${classes.endIcon}`]: {
        marginLeft: spacing(0.5)
      }
    },
    sizeSm: {
      [`& > .${classes.startIcon}`]: {
        marginRight: spacing(0.5)
      },
      [`& > .${classes.endIcon}`]: {
        marginLeft: spacing(0.5)
      }
    },
    sizeMd: {
      [`& > .${classes.startIcon}`]: {
        marginRight: spacing(0.5)
      },
      [`& > .${classes.endIcon}`]: {
        marginLeft: spacing(0.5)
      }
    },
    sizeLg: {
      [`& > .${classes.startIcon}`]: {
        marginRight: spacing(0.75)
      },
      [`& > .${classes.endIcon}`]: {
        marginLeft: spacing(0.75)
      }
    },
    sizeXl: {
      [`& > .${classes.startIcon}`]: {
        marginRight: spacing(0.75)
      },
      [`& > .${classes.endIcon}`]: {
        marginLeft: spacing(0.75)
      }
    },
    sizeXxl: {
      [`& > .${classes.startIcon}`]: {
        marginRight: spacing(0.75)
      },
      [`& > .${classes.endIcon}`]: {
        marginLeft: spacing(0.75)
      }
    }
  };
});
var _default = exports.default = useStyles;